import type { PlayerRace, ShipId } from '@kaeliux/shared';

// Humans
import h1 from '../assets/images/humans/ships/1.png';
import h2 from '../assets/images/humans/ships/2.png';
import h3 from '../assets/images/humans/ships/3.png';
import h4 from '../assets/images/humans/ships/4.png';
import h5 from '../assets/images/humans/ships/5.png';
import h6 from '../assets/images/humans/ships/6.png';
import h7 from '../assets/images/humans/ships/7.png';
import h8 from '../assets/images/humans/ships/8.png';
import h9 from '../assets/images/humans/ships/9.png';
import h10 from '../assets/images/humans/ships/10.png';
import h11 from '../assets/images/humans/ships/11.png';
import h12 from '../assets/images/humans/ships/12.png';
import h13 from '../assets/images/humans/ships/13.png';

// Robots
import r1 from '../assets/images/robots/ships/1.png';
import r2 from '../assets/images/robots/ships/2.png';
import r3 from '../assets/images/robots/ships/3.png';
import r4 from '../assets/images/robots/ships/4.png';
import r5 from '../assets/images/robots/ships/5.png';
import r6 from '../assets/images/robots/ships/6.png';
import r7 from '../assets/images/robots/ships/7.png';
import r8 from '../assets/images/robots/ships/8.png';
import r9 from '../assets/images/robots/ships/9.png';
import r10 from '../assets/images/robots/ships/10.png';
import r11 from '../assets/images/robots/ships/11.png';
import r12 from '../assets/images/robots/ships/12.png';
import r13 from '../assets/images/robots/ships/13.png';

// Axons
import a1 from '../assets/images/axons/ships/1.png';
import a2 from '../assets/images/axons/ships/2.png';
import a3 from '../assets/images/axons/ships/3.png';
import a4 from '../assets/images/axons/ships/4.png';
import a5 from '../assets/images/axons/ships/5.png';
import a6 from '../assets/images/axons/ships/6.png';
import a7 from '../assets/images/axons/ships/7.png';
import a8 from '../assets/images/axons/ships/8.png';
import a9 from '../assets/images/axons/ships/9.png';
import a10 from '../assets/images/axons/ships/10.png';
import a11 from '../assets/images/axons/ships/11.png';
import a12 from '../assets/images/axons/ships/12.png';
import a13 from '../assets/images/axons/ships/13.png';

const SHIP_SPRITES: Record<PlayerRace, Record<ShipId, string>> = {
    humans: { 1: h1, 2: h2, 3: h3, 4: h4, 5: h5, 6: h6, 7: h7, 8: h8, 9: h9, 10: h10, 11: h11, 12: h12, 13: h13 },
    robots: { 1: r1, 2: r2, 3: r3, 4: r4, 5: r5, 6: r6, 7: r7, 8: r8, 9: r9, 10: r10, 11: r11, 12: r12, 13: r13 },
    axons: { 1: a1, 2: a2, 3: a3, 4: a4, 5: a5, 6: a6, 7: a7, 8: a8, 9: a9, 10: a10, 11: a11, 12: a12, 13: a13 },
};

/** Resolves the sprite for a ship, for the given race. */
export function getShipIcon(race: PlayerRace, shipId: ShipId): string {
    return SHIP_SPRITES[race][shipId];
}
